/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesOrderDeveloperPayload } from './FxIdDomainEntitiesOrderDeveloperPayload';
import {
    instanceOfFxIdDomainEntitiesOrderDeveloperPayload,
    FxIdDomainEntitiesOrderDeveloperPayloadFromJSON,
    FxIdDomainEntitiesOrderDeveloperPayloadFromJSONTyped,
    FxIdDomainEntitiesOrderDeveloperPayloadToJSON,
} from './FxIdDomainEntitiesOrderDeveloperPayload';

/**
 * @type FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload
 * 
 * @export
 */
export type FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload = FxIdDomainEntitiesOrderDeveloperPayload;

export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSON(json: any): FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload {
    return FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesOrderDeveloperPayload(json)) {
        return FxIdDomainEntitiesOrderDeveloperPayloadFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSON(json: any): any {
    return FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSONTyped(value?: FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesOrderDeveloperPayload(value)) {
        return FxIdDomainEntitiesOrderDeveloperPayloadToJSON(value as FxIdDomainEntitiesOrderDeveloperPayload);
    }

    return {};
}

